var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('img',{class:['wptv-icon', { 'mirror': _vm.mirror, 'invert': _vm.invert, 'drop-shadow': _vm.shadow, 'opacity': _vm.opacity }],style:(_vm.styles),attrs:{"src":_vm.iconPath,"alt":_vm.alt}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }